import React, { useCallback, useRef, useEffect, useState } from 'react';

import { Container, Content, Background, AnimatedDiv2 } from './styles';

import PodcastLibraryComponent from '../../components/PodcastLibrary';
import { useSocket } from '../../hooks/Socket';


const PodcastLibrary: React.FC = () => {
  const { socket } = useSocket();


  return (
    <Container>
      <PodcastLibraryComponent />
    </Container>
  );
};
export default PodcastLibrary;
